import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelDynamic as _vModelDynamic, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "login-wrapper d-flex flex-wrap overflow-hidden" }
const _hoisted_2 = { class: "login-form-wrap" }
const _hoisted_3 = { class: "login-form" }
const _hoisted_4 = { class: "form-group mb-15" }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = { class: "form-group mb-20 position-relative" }
const _hoisted_7 = { class: "input-with-icon" }
const _hoisted_8 = ["type", "disabled"]
const _hoisted_9 = {
  key: 0,
  class: "alert alert-danger mb-3"
}
const _hoisted_10 = ["disabled"]
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[9] || (_cache[9] = _createElementVNode("div", { class: "login-bg" }, null, -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_router_link, {
          to: "/",
          class: "logo",
          style: {"display":"block","text-align":"center","color":"#B18164","text-transform":"uppercase","font-weight":"bold","font-size":"24px","text-decoration":"none"}
        }, {
          default: _withCtx(() => _cache[4] || (_cache[4] = [
            _createTextVNode(" AURABÊ ")
          ])),
          _: 1,
          __: [4]
        }),
        _createElementVNode("form", {
          onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => ($setup.handleSubmit && $setup.handleSubmit(...args)), ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_4, [
            _cache[5] || (_cache[5] = _createElementVNode("label", { class: "d-block fs-14 text-black mb-2" }, " Email/Phone Number ", -1)),
            _withDirectives(_createElementVNode("input", {
              type: "email",
              id: "username",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.username) = $event)),
              class: "w-100 h-55 bg_ash border-0 rounded-1 fs-14 text-title",
              placeholder: "adminKODE@gmail.com",
              disabled: $setup.isLoading
            }, null, 8, _hoisted_5), [
              [_vModelText, $setup.username]
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _cache[6] || (_cache[6] = _createElementVNode("label", { class: "d-block fs-14 text-black mb-2" }, "Password", -1)),
            _createElementVNode("div", _hoisted_7, [
              _withDirectives(_createElementVNode("input", {
                type: $setup.showPassword ? 'text' : 'password',
                id: "password",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.password) = $event)),
                placeholder: "Enter Password",
                class: "w-100 h-55 bg_ash border-0 rounded-1 fs-14 text-black",
                disabled: $setup.isLoading
              }, null, 8, _hoisted_8), [
                [_vModelDynamic, $setup.password]
              ]),
              _createElementVNode("span", {
                class: "password-toggle",
                onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.showPassword = !$setup.showPassword))
              }, [
                _createElementVNode("i", {
                  class: _normalizeClass($setup.showPassword ? 'far fa-eye-slash' : 'far fa-eye')
                }, null, 2)
              ])
            ])
          ]),
          ($setup.errorMessage)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _cache[7] || (_cache[7] = _createElementVNode("i", { class: "fas fa-exclamation-circle me-2" }, null, -1)),
                _createTextVNode(_toDisplayString($setup.errorMessage), 1)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("button", {
            type: "submit",
            class: "btn login-btn w-100 d-block",
            disabled: $setup.isLoading
          }, [
            (!$setup.isLoading)
              ? (_openBlock(), _createElementBlock("span", _hoisted_11, "Login"))
              : (_openBlock(), _createElementBlock("span", _hoisted_12, _cache[8] || (_cache[8] = [
                  _createElementVNode("i", { class: "fas fa-spinner fa-spin" }, null, -1),
                  _createTextVNode(" Connexion en cours... ")
                ])))
          ], 8, _hoisted_10)
        ], 32)
      ])
    ])
  ]))
}